import {
	SliceCaseReducers,
	SliceSelectors,
	createSelector,
	createSlice,
	type PayloadAction,
} from "@reduxjs/toolkit/react";
import { ApplicationState } from ".";

interface FilterProperty {
	type: "property";
	value: string;
}

export type DataFilter = FilterProperty;

const initialState: DataFilter = { type: "property", value: "" };

const slice = createSlice<
	DataFilter,
	SliceCaseReducers<DataFilter>,
	"dataFilters",
	SliceSelectors<DataFilter>,
	"dataFilters"
>({
	name: "dataFilters",
	initialState,
	reducers: {
		setFilter: (_state, { payload }: PayloadAction<DataFilter>) => payload,
	},
});

// ----------------
// exports
const selectDataFilter = (state: ApplicationState): DataFilter => state.dataFiltersState;
export const selectDataPropertyFilter = createSelector(selectDataFilter, ({ type, value }): string =>
	type === "property" && value.length > 2 ? value : ""
);

export const actions = {
	...slice.actions,
};
export const reducer = slice.reducer;
